export const MiniSitesConstants = {
    FETCH_MINI_SITES_RELOAD_COMPONENT: 'FETCH_MINI_SITES_RELOAD_COMPONENT',
    FETCH_MINI_SITES_RELOAD_STOP_COMPONENT: 'FETCH_MINI_SITES_RELOAD_STOP_COMPONENT',
    FETCH_MINI_SITES_PENDING: 'FETCH_MINI_SITES_PENDING',
    FETCH_MINI_SITES_ERROR: 'FETCH_MINI_SITES_ERROR',
    FETCH_MINI_SITES_GET_LIST_DOMAIN_SUCCESS: 'API_FETCH_MINI_SITES_GET_LIST_DOMAIN_SUCCESS',
    FETCH_MINI_SITES_GET_ISVALID_SUBDOMAIN_SUCCESS: 'API_FETCH_MINI_SITES_GET_ISVALID_SUBDOMAIN_SUCCESS',
    FETCH_MINI_SITES_GET_ISVALID_SUBDOMAIN_INVALID: 'API_FETCH_MINI_SITES_GET_ISVALID_SUBDOMAIN_INVALID',
    FETCH_MINI_SITES_SET_ATTRIBUTES: 'FETCH_MINI_SITES_SET_ATTRIBUTES',
    FETCH_MINI_SITES_SET_ATTRIBUTES_HTML: 'FETCH_MINI_SITES_SET_ATTRIBUTES_HTML',
    FETCH_MINI_SITES_GET_LIST_EVENTS_SUCCESS: 'API_FETCH_MINI_SITES_GET_LIST_EVENTS_SUCCESS',
    FETCH_MINI_SITES_SET_ATTRIBUTES_SELECT_LIST_EVENTS_SUCCESS: 'FETCH_MINI_SITES_SET_ATTRIBUTES_SELECT_LIST_EVENTS_SUCCESS',
    FETCH_MINI_SITES_SET_ACTIVE_STEP: 'FETCH_MINI_SITES_SET_ACTIVE_STEP',
    FETCH_MINI_SITES_SAVE_SUCCESS: 'API_FETCH_MINI_SITES_SAVE_SUCCESS',
    FETCH_MINI_SITES_GET_BACKOFFICE_URL_SUCCESS: 'API_FETCH_MINI_SITES_GET_BACKOFFICE_URL_SUCCESS',
    FETCH_MINI_SITES_GET_LIST_MINISITES_SUCCESS: 'API_FETCH_MINI_SITES_GET_LIST_MINISITES_SUCCESS',
    FETCH_MINI_SITES_GET_MINISITE_SUCCESS: 'API_FETCH_MINI_SITES_GET_MINISITE_SUCCESS',
    FETCH_MINI_SITES_SEARCH_EVENTS_SUCCESS: 'API_FETCH_MINI_SITES_SEARCH_EVENTS_SUCCESS',
    FETCH_MINI_SITES_SET_ATTRIBUTES_SELECT_LIST_EVENT: 'FETCH_MINI_SITES_SET_ATTRIBUTES_SELECT_LIST_EVENT',
    FETCH_MINI_SITES_SEARCH_NOTIFICATIONS_SUCCESS: 'API_FETCH_MINI_SITES_SEARCH_NOTIFICATIONS_SUCCESS',
    FETCH_MINI_SITES_SET_ATTRIBUTES_SELECT_LIST_NOTIFICATIONS: 'FETCH_MINI_SITES_SET_ATTRIBUTES_SELECT_LIST_NOTIFICATIONS',
    FETCH_MINI_SITES_UPDATE_SUCCESS:'API_FETCH_MINI_SITES_UPDATE_SUCCESS',
    FETCH_MINI_SITES_GET_ISVALID: 'FETCH_MINI_SITES_GET_ISVALID',
    FETCH_MINI_SITES_CLEAR: 'FETCH_MINI_SITES_CLEAR',
};